// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2VR0P","left":"StickyBox_left__IiHcJ","right":"StickyBox_right__6Y1wB"};